import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { ITouchPointConfiguration } from '../../../common/interfaces/dtos/ITouchPointConfiguration';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';

export const getFullTouchPointConfiguration = async (
  domainName: string,
  touchPointIdentifier: string,
): Promise<ITouchPointConfiguration> => {
  const axiosConfig: AxiosRequestConfig = {
    method: 'GET',
    url: `/touchPoint/configuration/${encodeURIComponent(domainName)}/${encodeURIComponent(
      touchPointIdentifier,
    )}`,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
    spanOptions: { name: 'get-touchpoint-config' },
  };

  return emeraldRequest(emeraldRequestParams);
};
